module.exports = __webpack_public_path__ + "img/left.5fc8776b.svg";